/**
 * @use https://aegis.woa.com/sdk/web.html#usage
 * @desc aegis
 * @time 2023-08-24 17:36:32
 * @user simxin
 */

// import Aegis from 'aegis-web-sdk';
// import AegisV2 from '@tencent/aegis-web-sdk-v2';
import { getUin } from '@src/utils/cookies';

// const blacklist = [
//   'InternalError',
//   'RegionError',
//   'InvalidParameter',
//   'MissingParameter',
//   'UnknownParameter',
// ];

// export const mountAegis = () => {
//   const aegis = new Aegis({
//     id: process.env.VITE_ENV_AEGIS_PROJECT,
//     uin: getUin() || '-',
//     reportApiSpeed: true,
//     reportAssetSpeed: true,
//     spa: true,
//     hostUrl: 'https://rumt-sg.com',
//     api: {
//       apiDetail: true,
//       retCodeHandler(data: any, url: string, xhr: any) {
//         try {
//           data = JSON.parse(data);
//           if (data.error || blacklist.some(e => data.code === e)) {
//             // 如果是 正常登录态问题 ，则不上报。
//             // "code":-40002,"message":"check login flag fail | user login time expired",
//             const loginErrorCodes = [-4, 50, -40002];
//             if (loginErrorCodes?.includes(data.code)) {
//               return {
//                 isErr: false,
//                 code: 0,
//               };
//             }
//             return {
//               isErr: true,
//               code: data.code,
//             };
//           }
//         } catch (e) {
//           const type = xhr?.body?.constructor?.name;
//           const isZip = url?.endsWith('zip');
//           const isBlob = [
//             'Blob',
//             'ReadableStream',
//             'ArrayBuffer',
//             'Document',
//           ].includes(type);
//           if (isBlob || isZip) {
//             return {
//               isErr: false,
//               code: 0,
//             };
//           }
//           return {
//             isErr: true,
//             code: 0,
//           };
//         }

//         return {
//           isErr: false,
//           code: 0,
//         };
//       },
//     },

//     beforeRequest: function (data: any) {
//       const msg = data?.logs?.msg ?? '';
//       // 拦截chrome插件的上报
//       if (msg?.indexOf?.('chrome-extension') > -1) {
//         return false;
//       }
//       if (
//         msg?.indexOf?.("Failed to execute 'removeChild' on 'Node'") > -1 ||
//         msg?.indexOf?.("Failed to execute 'insertBefore' on 'Node'") > -1
//       ) {
//         data.logs.msg = '浏览器翻译插件导致问题，请用户关闭插件后重试！';
//       }
//       if (msg?.indexOf?.('md5:10') > -1) {
//         return false;
//       }

//       if (msg?.startsWith?.('Script error.')) {
//         return false;
//       }
//       return data;
//     },
//   });

//   window.aegis = aegis;

//   // // // AegisV2
//   // const url = "https://aegis.log.zhiyan.tencent-cloud.net/collect"; // 日志汇上报地址
//   // const id = process.env.VITE_ENV_AEGISV2_ID;
//   // const aegisV2 = new AegisV2({
//   //   id,
//   //   hostUrl: { url },
//   //   uid: document.cookie.match(/saas_uin=([^;]+)/)?.[1],
//   //   plugin: {
//   //     pv: true,
//   //     aid: true,
//   //     error: true,
//   //     device: true,
//   //     close: true,
//   //     pagePerformance: true,
//   //     webVitals: true,
//   //     fId: false,
//   //     ie: false,
//   //     spa: false,
//   //     assetSpeed: false,
//   //     session: true,
//   //     api: {
//   //       apiDetail: true,
//   //       reportAbort: true,
//   //     },
//   //   }
//   // })
//   // window.AegisV2 = aegisV2;
// };

export const setAegisUin = () => {
  const cookieUin = getUin();
  if (cookieUin) {
    // window.aegis?.setConfig({ uin: cookieUin });
    window.AegisV2?.setConfig?.({
      uid: cookieUin,
    });
  }
};
